'use strict';

var createjs = createjs || {};

createjs.Artboard = class {

	static get manifest() {
		return []
	}

	static get preloader(){
		let pl = new createjs.Shape();
		pl.graphics.beginFill('#000000');
		pl.graphics.drawRect(0, 0, 1, 1);
		pl.graphics.endFill();
		return pl;
	}

	static get defaultOptions() {
		return {
			width: 600,
			height: 600,
			enableTouch: true,
			enableMouseOver: true,
			backgroundColor: '#eeeeee',
			showPreloader: true,
			autoLoadAssets: true,
			assetBaseDir: "/assets/img/"
		}
	}

	constructor(canvas, options) {
		this.canvas = canvas;
		this.options = $.extend({}, this.constructor.defaultOptions, options);
		this.assets = {};
		this.debug = false;

		_.bindAll(this, 'init', 'render', 'tick', 'onLoadFile', 'onLoadComplete', 'onOverallProgress', 'onLoadError', 'enableInteraction', 'disableInteraction');
		return this;
	}


	init() {
		//size
		this.canvas.width = this.options.width;
		this.canvas.height = this.options.height;

		// create stage and point it to the canvas:
		this.stage = new createjs.Stage(this.canvas);

		// enable touch interactions if supported on the current device:
		if(this.options.enableTouch) createjs.Touch.enable(this.stage);

		// enabled mouse over / out events
		if(this.options.enableMouseOver) {
			this.stage.enableMouseOver(10);
			this.stage.mouseMoveOutside = true; // keep tracking the mouse even when it leaves the this.canvas
		}

		//background
		if(this.options.backgroundColor) {
			this._background = new createjs.Shape();
			this._background.graphics.beginFill(this.options.backgroundColor);
			this._background.graphics.drawRect(0, 0, this.options.width, this.options.height);
			this._background.graphics.endFill();
			this.stage.addChild(this._background);
		}

		//preloader
		if(this.options.showPreloader) {
			this._preloader = this.constructor.preloader;
			this._preloader.scaleX = 0;
			this._preloader.scaleXEnd = this.options.width;
			this._preloader.scaleY = this.options.height;
			this.stage.addChild(this._preloader);
		}

		//load assets with a loadQueue
		this._loadQueue = new createjs.LoadQueue();
		this._loadQueue.on("complete", this.onLoadComplete);
		this._loadQueue.on("fileload", this.onLoadFile);
		this._loadQueue.on("progress", this.onOverallProgress);
		this._loadQueue.on("error", this.onLoadError);
		this._loadQueue.setMaxConnections(5);
		this._loadQueue.loadManifest(this.constructor.manifest, this.options.autoLoadAssets, this.options.assetBaseDir);

		return this;
	}

	// File complete handler
	onLoadFile(evt) {
		if(this.debug) console.log('onLoadFile', evt);

		//TODO make sure id exists
		let id = evt.item.id;
		this.assets[id] = {id: id, data: evt.result};
	}

	// Overall progress handler
	onOverallProgress(evt) {
		if(this.debug) console.log('onOverallProgress', evt);
		this._preloader.scaleX = this._preloader.scaleXEnd * evt.loaded / evt.total;
		this.stage.update();
	}

	// File complete handler
	onLoadComplete(evt) {
		if(this.debug) console.log('onLoadComplete', evt);

		//remove preloader
		if(this._preloader) this._preloader.parent.removeChild(this._preloader);

		//update stage with 60fps
		createjs.Ticker.setFPS(60);
		createjs.Ticker.addEventListener('tick', this.tick);
	}

	// An error happened on a file
	onLoadError(event) {
		console.error('onLoadError', event);
	}

	disableInteraction() {
		createjs.Touch.disable(this.stage);
		this.stage.mouseEnabled = false;
	}

	enableInteraction() {
		if(this.options.enableTouch) createjs.Touch.enable(this.stage);
		this.stage.mouseEnabled = true;
	}

	/**
	 * computations that happen every frame
	 */
	render(){
		if(this.debug) console.log('render', this);
		return this;
	}

	tick(){
		this.render();
		this.stage.update();
	}
};